import Vue from "vue"
import { Mutations, Actions } from "./types"
import { AdminUserState, IMutations, IActions } from "./adminUserType"

function _init(): AdminUserState {
  return {
    id: null,
    email: null,
    description: null,
    name: null,
    position: null,
    role: null,
    thumbnail: null,
    twitterUrl: null,
    instagramUrl: null,
    youtubeUrl: null,
    linkUrl: null,
  }
}

const state = _init()

const mutations: Mutations<AdminUserState, IMutations> = {
  initAdminUser(_state) {
    const newState = _init()
    Object.entries(newState).forEach(([k, v]) => {
      Vue.set(_state, k, v)
    })
  },
  updateAdminUser(_state, payload) {
    Object.entries(payload).forEach(([k, v]) => {
      Vue.set(_state, k, v)
    })
  },
}
const actions: Actions<AdminUserState, IActions, any, IMutations, any, any> = {
  initAdminUser(context) {
    context.commit("initAdminUser")
  },
  updateAdminUser(context, payload) {
    context.commit("updateAdminUser", payload)
  },
}

export const adminUser = {
  namespaced: true,
  state,
  mutations,
  actions,
}
